/**
 * Canvas Rectangle
 */
import CanvasParent from "./CanvasParent";
import canvTools from "./canvas-tools";
export default class CanvasRectangle extends CanvasParent {

  type = 'rectangle';

  constructor(width, height, id) {
    super(width, height, id);
    document.addEventListener('click', this._clickRect);
    this.onChange = canvTools.onChange;
  }

  draw = () => {
    canvTools.drawMultipleLine(this);
  }

  _clickRect = (event) => {
    // if (this.mouseIn === false) return;
    if (this.clicked === false) {
      this.clicked = true;
      document.addEventListener('mousemove', this._listenDrawRect);
      this.currentLine.start = [event.pageX - this.offsetLeft, event.pageY - this.offsetTop];
    } else {
      this.clicked = false;
      this.valided = true;
      document.removeEventListener('click', this._clickRect);
      document.removeEventListener('mousemove', this._listenDrawRect);
      this.stopListenMouse();
    }
  }

  _listenDrawRect = (event) => {
    let xMin = this.offsetLeft;
    let xMax = this.offsetLeft + this.width;
    let yMin = this.offsetTop;
    let yMax = this.offsetTop + this.height;
    let endX, endY;
    if (event.pageX > xMax) endX = xMax - this.offsetLeft;
    else if (event.pageX < xMin) endX = xMin - this.offsetLeft;
    else endX = event.pageX - this.offsetLeft;

    if (event.pageY > yMax) endY = yMax - this.offsetTop;
    else if (event.pageY < yMin) endY = yMin - this.offsetTop;
    else endY = event.pageY - this.offsetTop;
    
    this.currentLine.end = [endX, endY];
    this.positions = this.createRectPos()
    this.draw(this);
  }


  createRectPos = () => {
    let start = this.currentLine.start;
    let end = this.currentLine.end;
    let top = {start: start, end: [end[0], start[1]]};
    let right = {start: [end[0], start[1]], end: end};
    let bottom = {start: end, end: [start[0], end[1]]};
    let left = {start: [start[0], end[1]], end: start};
    return [top, right, bottom, left];
  }
}